@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../../constants/spacing.module.less';
@import (reference) '../../../style.module.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';

@aliasDeleteWidth: 128px;

.aliases-tab {
  padding: @space-0 @space-16 @space-16;
}

.content-card {
  background-color: var(--white);
  border: 1px solid var(--default--border-color--10);
  border-radius: @space-4;
  padding: @space-16;
}

.aliases-options {
  margin-top: @space-8;
  border: 1px solid var(--gray-DFE4E8);
  border-radius: @space-4;
  overflow: hidden;
}

// Header

.alias-header {
  display: flex;
  width: 100%;
  background-color: @table--header--background-color;
  border-bottom: 1px solid var(--gray-DFE4E8);
  padding: 0 5px;
  margin-bottom: 10px;
}

.alias-header > div {
  padding: 10px;
  flex: 1;
}

.alias-header .alias-header-actions {
  width: @aliasDeleteWidth;
  flex: none;
  padding: @space-8 @space-16;
  text-align: center;
}

// List

.store-alias-list {
  min-height: 100px;
  overflow-y: auto;
}

.alias-list-empty {
  text-align: center;
  width: 100%;
  margin: 20px 0;
}

// Row

.alias-row {
  display: flex;
  padding: 5px 10px;
}

.alias-row + .alias-row {
  border-top: 1px solid var(--gray-DFE4E8);
}

.alias-row > div {
  padding: 10px;
  flex: 1;
}

.alias-row .alias-input {
  padding: 0 20px 0 0;
  height: 35px;
}

.alias-row .alias-input Input {
  .input-border-base-style();
}

.alias-row .store-selector {
  padding: 0 10px 0 0;
}

.alias-row .store-selector select {
  padding: 5px;
}

.alias-row .alias-delete {
  width: @aliasDeleteWidth;
  height: 100%;
  flex: none;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.delete-item {
  cursor: pointer;
  height: 100%;
}

.delete-item svg {
  fill: @product-page--alias-delete--icon-color;
}

.delete-item:hover svg {
  fill: @product-page--alias-delete--hover--icon-color;
}
